module.exports = __webpack_public_path__ + "static/media/banner-e1.62e94feb.jpg";